// import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
// import {provideRouter} from '@angular/router';

// import {routes} from './app.routes';
// import {provideClientHydration} from '@angular/platform-browser';
// import {provideToastr} from 'ngx-toastr';
// import {provideAnimations} from '@angular/platform-browser/animations';
// //import {provideHttpClient} from '@angular/common/http';
// import { provideHttpClient, withInterceptors } from '@angular/common/http';
// import { authInterceptor } from './core/interceptors/auth.interceptor';




// export const appConfig: ApplicationConfig = {
//   providers: [provideZoneChangeDetection({eventCoalescing: true}),
//     provideRouter(routes),
//     provideClientHydration(),
//     provideAnimations(),
//     provideToastr({
//       positionClass: 'toast-top-right',
//       progressBar: true,
//       timeOut: 3000,
//       easing : "ease-in",
//       easeTime : 300,
//       preventDuplicates: true,
//     }),
//    // provideHttpClient(),
//     provideHttpClient(
//       withInterceptors([authInterceptor]) )//Add  interceptor 
//   ]
// };

// app.config.ts - Updated to handle hydration properly
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withPreloading, PreloadAllModules, withInMemoryScrolling } from '@angular/router';
import { provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

// Import your routes
import { routes } from './app.routes';

// Import your services if they need to be provided at root level
import { AppConfigService } from './config/app-config.service';
import { AuthService } from './core/services/auth/auth.service';
import { HrAuthServiceService } from './core/services/hr_auth/hr-auth-service.service';
import { authInterceptor } from './core/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    // Zone.js optimization - coalesce events for better performance
    provideZoneChangeDetection({ eventCoalescing: true }),
    
    // Router with blocking initial navigation, preloading and scroll restoration
    provideRouter(
      routes, 
      withEnabledBlockingInitialNavigation(),
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled'
      })
    ),
    
    // HTTP client with fetch API and interceptors
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor]),
      withInterceptorsFromDi() // If you have HTTP interceptors registered via DI
    ),
    
    // Client hydration with optimizations
    provideClientHydration(
      withNoHttpTransferCache() // Disable if causing issues with your API calls
    ),
    
    // Browser animations
    importProvidersFrom(BrowserAnimationsModule),
    
    // Toastr configuration
    importProvidersFrom(
      ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        // Optimize for hydration
        enableHtml: false,
        tapToDismiss: true,
        closeButton: true,
        maxOpened: 3,
        autoDismiss: true
      })
    ),
    
    // Your services (if they need root-level injection)
    AppConfigService,
    AuthService,
    HrAuthServiceService,
    
    // Add any other providers your app needs
  ],
};